import { CurrencyListPage, CurrencyEditPage, CurrencyCreatePage } from './imports';

export const currencyRoutes = [
  {
    path: 'currencies',
    children: [
      { element: <CurrencyListPage />, index: true },
      { path: 'list', element: <CurrencyListPage /> },
      { path: ':id/edit', element: <CurrencyEditPage /> },
      { path: 'new', element: <CurrencyCreatePage /> },
    ],
  },
];
